import React, { useEffect, useState } from 'react';
import Preloader from '../../Components/Preloader';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { NavLink } from 'react-router-dom';
import Complaint_Policy_Seo from '../../SEO/Complaint_Policy_Seo';

function ComplaintPolicy() {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        // Simulate an asynchronous operation (e.g., fetching data)
        setTimeout(() => {
            setIsLoading(false);
        }, 500); // Simulating a 1-second delay
    }, []);
    return (
        <div>
            {isLoading ? (
                <Preloader />
            ) : (
                <>
                    <Complaint_Policy_Seo />
                    <div className="page-wrapper">
                        <Header />
                        {/* Internal CSS */}
                        <style>
                            {`
                            .header-wrap.style1 .header-top .header-top-left .contact-item a, 
                            .header-wrap.style1 .header-top .header-top-right .social-profile li a i {
                                color: #fff;
                            }
                            .header-wrap.style1 .header-top .header-top-left .contact-item a:hover, 
                            .header-wrap.style1 .header-top .header-top-right .social-profile li a:hover i {
                                color: #FF414B;
                            }
                        `}
                        </style>
                        {/* Content Wrapper Start */}
                        <div className="content-wrapper">
                            {/* Breadcrumb start */}
                            <div className="breadcrumb-wrap bg-f">
                                <div className="overlay bg-vulcan op-9" />
                                <div className="container">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className="breadcrumb-title">
                                                <h2>Complaints Policy</h2>
                                                <ul className="breadcrumb-menu list-style">
                                                    <li><NavLink to="/">Home </NavLink></li>
                                                    <li>Complaints Policy</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Breadcrumb end */}
                            {/* Complaints Policy section start */}
                            <section className="terms-wrap ptb-100">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-xl-12 col-lg-12">
                                            <div className="faq-content">
                                                <div className="faq-item">
                                                    <h4>Our complaints policy</h4>
                                                    <p className="mb-2">
                                                        We are committed to providing a high-quality money transfer service to all our clients. When something goes wrong, we need you to tell us about it. This will help us to improve our standards.
                                                    </p>
                                                    <p>
                                                        If you have a complaint, please contact us with the details.
                                                    </p>
                                                </div>
                                                <div className="faq-item">
                                                    <h4>Definitions</h4>
                                                    <ul className="features two mt-2">
                                                        <li>
                                                            By Email: <NavLink to="mailto:info@finestpay.co.uk">info@finestpay.co.uk</NavLink>
                                                        </li>
                                                        <li>
                                                            By Phone: <NavLink to="tel:02036523240">020 3652 3240</NavLink>
                                                        </li>
                                                        <li className="end">
                                                            By Post: <NavLink to="/" target="_blank">30, Ridley Road, Dalston, London, United Kingdom. E8 2NR</NavLink>
                                                        </li>
                                                    </ul>
                                                    <p className="mt-2">
                                                        We have eight weeks to consider your complaint. If we have not resolved it within this time you may complain to the Financial Ombudsman Service.
                                                    </p>
                                                </div>
                                                <div className="faq-item">
                                                    <h4>What will happen next?</h4>
                                                    <ul className="features two mt-2">
                                                        <li>
                                                            We will send you a letter/email acknowledging receipt of your complaint on the same day of receiving it, enclosing a copy of this procedure. If you have complained in person or on call, we will try to resolve and reach the solution the same day.
                                                        </li>
                                                        <li>
                                                            If we are unable to resolve your complaint on the same day then we will further investigate your complaint. This will normally involve finding details of your complaint, reviewing your matter by speaking to the member of staff who acted for you.
                                                        </li>
                                                        <li>
                                                            We will respond to you within 7 days with our Final Response which may be a remedial action.
                                                        </li>
                                                        <li className="end">
                                                            If you are still not satisfied, you can then contact the Financial Ombudsman Service, about your complaint. Normally, you will need to bring a complaint to the Financial Ombudsman Service within six months of receiving a final written response from us about your complaint. For further information, you should contact the Financial Ombudsman Service on:
                                                            <ul className="mt-2">
                                                                <li>
                                                                    Online: <NavLink to="https://www.financial-ombudsman.org.uk/" target="_blank">https://www.financial-ombudsman.org.uk/</NavLink>
                                                                </li>
                                                                <li>
                                                                    Email: <NavLink to="mailto:complaint.info@financial-ombudsman.org.uk">complaint.info@financial-ombudsman.org.uk</NavLink> ,
                                                                </li>
                                                                <li>
                                                                    By post: The Financial Ombudsman Service Exchange Tower, London, E14 9SR
                                                                </li>
                                                                <li>
                                                                    Phone: <NavLink to="tel:08000234567">0800 023 4 567</NavLink> (free), <NavLink to="tel:03001239123">0300 123 9 123</NavLink>, weekdays from 8:00am - 8:00pm (GMT), and on Saturday from 9:00 - 1:00pm (GMT).
                                                                </li>
                                                            </ul>
                                                        </li>
                                                        <li>
                                                            If you're not in the UK, call <NavLink to="tel:02036523240">020 3652 3240</NavLink>.
                                                        </li>
                                                    </ul>
                                                    <p>
                                                        FOS will not charge you for making a complaint and if you are not satisfied with the outcome you can still bring legal proceedings. In addition, please note that disputes may also be submitted for online resolution via the European Online Dispute Resolution Platform accessible at: <NavLink to="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</NavLink>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            {/* Complaints Policy section end */}
                        </div>
                        {/* Content Wrapper End */}
                        {/* Footer Section Here */}
                        <Footer />
                    </div>
                </>
            )}
        </div>
    );
}

export default ComplaintPolicy
